<script setup lang="ts">
    import { useDisplay } from 'vuetify';
    import {
        useAppStore,
        useAuthStore,
        useEmployeeStore,
        useMessageStore,
        useRequestStore } from '#imports';

    /* Store variables */
    const { brandIcon, isMenu, isMobile, siteName, tagLine } = storeToRefs(useAppStore());
    const { currentLocationId, isDemo } = storeToRefs(useAuthStore());
    const { fetchEmployees } = useEmployeeStore();
    const { fetchMessages } = useMessageStore();
    const { fetchRequests } = useRequestStore();

    /* Private variables */
    const _display = useDisplay();
    const _url = useRequestURL();

    isDemo.value = _url.pathname.includes('/demo/');
    isMobile.value = computed(() => { return _display.mobile.value; });

    onMounted(async () => {
        console.log('onMounted().currentLocationId.value:', currentLocationId.value, _url);
        if (currentLocationId.value)
            fetchEmployees(currentLocationId.value, true);
            fetchMessages();
            fetchRequests(currentLocationId.value);
    })
</script>

<template>
    <v-app-bar>
        <template v-slot:prepend>
            <v-expand-x-transition>
                <div v-show="isMobile">
                    <v-app-bar-nav-icon
                        aria-label="Menu"
                        color="primary"
                        style="background: transparent; "
                        @click="isMenu = !isMenu" />
                </div>
            </v-expand-x-transition>
        </template>
        <v-app-bar-title :class="isMobile ? 'ml-0' : 'ml-3'">
            <div>
                <p class="brand-font color-primary mb-n1 d-flex align-end">
                    <v-icon :icon="brandIcon" color="primary" />
                    {{ siteName }}
                </p>
                <p class="text-caption color-secondary font-italic">{{ tagLine }}</p>
            </div>
        </v-app-bar-title>
        <LoginPseudoRole />
        <SiteSettings />
        <LoginLogInOutBtn />
    </v-app-bar>
</template>